<template>
  <div>
    <div v-if="$slots.default" class="nav-vertical nav-vertical--nested" style="display: block">
      <div class="nav-vertical__item flex-wrap filterOptionListItem py-0">
        <slot></slot>
      </div>
    </div>
    <div class="nav-vertical nav-vertical--nested" style="display: block">
      <div
        v-for="option in options"
        :key="option.id"
        class="nav-vertical__item flex-wrap cursor-pointer filterOptionListItem py-1"
      >
        <c-new-filter-item-radio-option
          v-bind="option"
          @input="onInput"
          :radio="radio"
          :name="name"
        ></c-new-filter-item-radio-option>
      </div>
    </div>
  </div>
</template>

<script>
import NewFilterItemRadioOption from '@/components/pages/filter/radio/NewFilterItemRadioOption.vue'

export default {
  components: { 'c-new-filter-item-radio-option': NewFilterItemRadioOption },
  props: {
    name: { required: true, type: String },
    options: { required: true, type: Array },
    radio: Boolean,
  },
  methods: {
    onInput(e) {
      this.$emit('filter-selected', e)
    },
  },
}
</script>
